module.exports = __webpack_public_path__ + "static/media/list-item.462ef2dc.md";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/list-item.md
// module id = 393
// module chunks = 0